import { API_ENDPOINT } from 'helper';

export const downloadReport = async (File_Name, accessToken) => {
    const url = `${API_ENDPOINT}/download?File_Name=${File_Name}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: accessToken,
            },
        });

        if (!response.ok) {
            throw new Error(await response.text());
        }

        return response.json();
    } catch (error) {
        throw error;
    }
};
